import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
} from 'react-router-dom';
import { Statistic } from '@b3w/react-statistic';
import MainPage from 'pages/MainPage/MainPage';
import ContentPage from 'pages/ContentPage/ContentPage';
import CategoryPage from 'pages/CategoryPage/CategoryPage';
import TextPage from 'pages/TextPage/TextPage';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import { ServiceQuery } from 'generated/graphql';
import { PATH_PREFIX, TEXT_OFFER, TEXT_PP } from 'routes/routes';

interface IRouterProps {
  data: ServiceQuery | undefined
}

const Router = ({ data }: IRouterProps) => (
  <BrowserRouter>
    <Header data={data} />
    <Statistic
      path={`${PATH_PREFIX}/referer/statistic`}
      from
      timeoutMinutes={1}
    />
    <Switch>
      <Route
        key="offer"
        path={`${PATH_PREFIX}/user/conditions`}
        component={() => <TextPage path={TEXT_OFFER} />}
      />
      <Route
        key="pppolicy"
        path={`${PATH_PREFIX}/privacypolicy`}
        component={() => <TextPage path={TEXT_PP} />}
      />
      <Route
        key="content"
        path={`${PATH_PREFIX}/:alias/:id`}
        component={ContentPage}
      />
      <Route
        key="category"
        path={`${PATH_PREFIX}/:alias`}
        component={CategoryPage}
      />
      <Route
        exact
        key="main"
        path={PATH_PREFIX}
        component={MainPage}
      />
    </Switch>
    <Footer data={data} />
  </BrowserRouter>
);

export default Router;
